import { css } from 'styled-components';
import styled from 'styled-components';
import { HeadingProps } from '.';
import { MediaQuery } from '../../../styles/global';

export const HeadingContainer = styled.h1<HeadingProps>`
  font-family: ${({font}) => (font === 'Campuni' && 'Campuni Test, sans-serif') || (font) || null};
  font-size: ${(props) =>
          (props.size === 'extra-large' && '40px') ||
          (props.size === 'large' && '24px') ||
          (props.size === 'medium' && '18px') ||
          (props.size === 'small' && '15px') ||
          '12px'};
  line-height: ${(props) =>
          (props.size === 'large' && '30px') ||
          (props.size === 'medium' && '23px') ||
          (props.size === 'small' && '19px') ||
          '15px'};
  color: ${(props) =>
          props.color === 'gray'
                  ? 'var(--gray-text)'
                  : props.color === 'blue'
                          ? 'var(--blue-100)'
                          : 'var(--black)'};
  font-weight: 700;
  letter-spacing: ${({ size }) => (size === 'small' ? '2.4px' : '')};

  ${({ size }) =>
    size === 'large' &&
    css`
      ${MediaQuery.md} {
        font-size: 20px;
        line-height: 25px;
      }

      ${MediaQuery.sm} {
        font-size: 18px;
        line-height: 23px;
      }
    `};
`;
